import React from 'react'

const Button = ({ button: { icon, text = '' }, button, log, allLogs, buttonHandle }) => {
	const onClick = () => buttonHandle(button, log, allLogs)

	return <div className='button' onClick={onClick}>
		{icon && <span className={`icon ${icon}`} /> || null}
		{text || '查看'}
	</div>
}

export default Button